<mat-dialog-content>
  <div class="content">
    <div class="header">
      <div class="title">職場/店舗 タグ管理</div>
      <div class="desc">※上限30</div>
      <div class="right"><button mat-raised-button type="button" (click)="onAdd()" class="add-btn" [disabled]="!btnEnable ||  lists.controls.length>29">追加</button></div>
    </div>
    <div class="list-area">

      @if (showSpinner) {

        <div class="spinner">
          <mat-spinner></mat-spinner>
        </div>

      } @else {

        <form [formGroup]="form">

          <table class="tag-table">

            <tbody
              formArrayName="lists"
              cdkDropList
              (cdkDropListDropped)="drop($event)">

              <tr
                *ngFor="let val of lists.controls; let i = index"
                [formGroupName]="i"
                cdkDrag
                [class.del]="val.value.del_flg==1">

                <ng-template cdkDragPreview [matchSize]="true">
                  <table class="tag-table preview-table">
                    <tbody>
                      <tr [class.del]="val.value.del_flg==1">

                        <td class="drag">
                          <mat-icon class="drag-icon">
                            drag_indicator
                          </mat-icon>
                        </td>

                        <td class="title">

                          <div
                            class="label-count"
                            [class.length-red]="title.value.length > 20">
                            {{ title.value.length }}/{{ titleMaxLen }}
                          </div>

                          <mat-form-field class="input-area no-line">
                            <input
                              matInput
                              [value]="val.get('title')?.value"
                              readonly>
                          </mat-form-field>

                        </td>

                        <td class="btn">

                          <button
                            mat-raised-button
                            class="del-btn"
                            *ngIf="val.value.del_flg != 1"
                            disabled>
                            削除
                          </button>

                          <button
                            mat-raised-button
                            class="cancel-btn"
                            *ngIf="val.value.del_flg == 1"
                            disabled>
                            取消
                          </button>

                        </td>

                      </tr>
                    </tbody>
                  </table>
                </ng-template>

                <td class="drag">
                  <mat-icon cdkDragHandle class="drag-icon">
                    drag_indicator
                  </mat-icon>
                </td>

                <td class="title">

                  <div
                    class="label-count"
                    [class.length-red]="title.value.length>20">
                    {{title.value.length}}/{{titleMaxLen}}
                  </div>

                  <mat-form-field class="input-area no-line">
                    <input
                      matInput
                      formControlName="title"
                      [maxlength]="titleMaxLen"
                      #title>
                  </mat-form-field>

                </td>

                <td class="btn">

                  <button
                    mat-raised-button
                    class="del-btn"
                    type="button"
                    (click)="onDel(i)">
                    削除
                  </button>

                  <button
                    mat-raised-button
                    class="cancel-btn"
                    type="button"
                    (click)="onDelCancel(i)">
                    取消
                  </button>

                </td>

              </tr>

            </tbody>

          </table>

        </form>

      }

    </div>

  </div>

</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="center">

  <button mat-raised-button mat-dialog-close>
    キャンセル
  </button>

  <button
    mat-raised-button
    (click)="onSave()"
    [disabled]="!btnEnable || form.invalid || isSaving"
    class="yes-btn">

    保存

  </button>

  @if (isSaving) {

    <mat-spinner
      diameter="28"
      class="spinner">
    </mat-spinner>

  }

</mat-dialog-actions>
